import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
const FormPage = ({ search }) => {
  const navigate = useNavigate();
  const [valueLabelMain, setValueLabelMain] = useState("¿cuál es tu nombre?");
  const [valueInputName, setValueInputName] = useState("");

  const [valueInputLastName, setValueInputLastName] = useState("");
  const [valueInputEmail, setValueInputEmail] = useState("");
  const [valueInputCel, setValueInputCel] = useState("");

  const [errorEmail, setErrorEmail] = useState(false);

  const [typeInput, setTypeInput] = useState("text");
  const [valueInputMain, setValueInputMain] = useState("");

  const [dropdownActive, setDropdownActive] = useState(false);
  const [valueDropdown, setValueDropdown] = useState("");
  const [steps, setSteps] = useState("1");
  const [keepStep, setKeepStep] = useState();
  const [isModificated, setIsModificated] = useState(false);

  const [optionsParents, setOptionsParents] = useState("");

  const [valueOther, setValueOther] = useState();

  useEffect(() => {
    optionsDropdown();
  }, []);

  const optionsDropdown = () => {
    const names = [
      {
        name: "Mamá",
      },
      {
        name: "Papá",
      },
      {
        name: "Hermano",
      },
      {
        name: "Hermana",
      },
      {
        name: "Amigo",
      },
      {
        name: "Amiga",
      },
      {
        name: "Hijo",
      },
      {
        name: "Hija",
      },
      {
        name: "Otro",
      },
    ];

    setOptionsParents(names);
  };

  const changePage = () => {
    const anims_left = document.querySelector(".anim_slider");
    anims_left.classList.remove("animate__bounceInRight");
    anims_left.classList.add("animate__bounceOutLeft");

    setTimeout(() => {
      navigate("/selecciona-audio-dos");
    }, 1000);
  };

  const handleUserInput = (e) => {
    setValueInputMain(e.target.value);
  };

  useEffect(() => {
    if (steps === "1") {
      setValueLabelMain("¿cuál es tu nombre?");
    } else if (steps === "2") {
      setValueLabelMain("¿cuál es tu apellido?");
    } else if (steps === "3") {
      setValueLabelMain("¿cuál es tu email?");
    } else if (steps === "4") {
      setValueLabelMain("¿cuál es tu celular?");
    } else if (steps === "5") {
      setValueLabelMain("¿Para quién es el video?");
    } else if (steps === "6") {
    }
  }, [steps]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && valueInputMain.length > 2) {
      if (steps === "1") {
        setValueInputName(e.target.value);

        document.querySelector(".labelName").classList.add("labelNameActive");
        document.querySelector(".circle_min:nth-of-type(1)").classList.add("complete");
        setTypeInput("text");
        if (isModificated) {
          setSteps(keepStep);
          setIsModificated(false);
        } else {
          setSteps("2");
        }
      }
      if (steps === "2") {
        setValueInputLastName(e.target.value);
        document.querySelector(".labelLastName").classList.add("labelLastNameActive");
        document.querySelector(".circle_min:nth-of-type(2)").classList.add("complete");
        setTypeInput("email");

        if (isModificated) {
          setSteps(keepStep);
          setIsModificated(false);
        } else {
          setSteps("3");
        }
      }

      if (steps === "3" && valueInputMain.includes("@")) {
        setValueInputEmail(e.target.value);
        document.querySelector(".labelEmail").classList.add("labelEmailActive");
        document.querySelector(".circle_min:nth-of-type(3)").classList.add("complete");
        setTypeInput("number");
        setErrorEmail(false);
        if (isModificated) {
          setSteps(keepStep);
          setIsModificated(false);
        } else {
          setSteps("4");
        }
      } else if (steps === "3") {
        setErrorEmail(true);
      }
      if (steps === "4") {
        setValueInputCel(e.target.value);
        document.querySelector(".labelCel").classList.add("labelCellActive");
        document.querySelector(".circle_min:nth-of-type(4)").classList.add("complete");

        if (isModificated) {
          setSteps(keepStep);
          setIsModificated(false);
        } else {
          setSteps("5");
        }
      }
      if (steps === "5") {
        document.querySelector(".labelParentage").classList.add("labelParentageActive");
        document.querySelector(".circle_min:nth-of-type(5)").classList.add("complete");

        if (isModificated) {
          setSteps(keepStep);
          setIsModificated(false);
        } else {
          setSteps("6");
        }
      }
      setValueInputMain("");
    }
  };

  const statusChange = (valueInputMain) => {
    if (steps === "1" && valueInputMain.length > 2) {
      setValueInputName(valueInputMain);

      document.querySelector(".labelName").classList.add("labelNameActive");
      document.querySelector(".circle_min:nth-of-type(1)").classList.add("complete");
      setTypeInput("text");
      if (isModificated) {
        setSteps(keepStep);
        setIsModificated(false);
      } else {
        setSteps("2");
      }
    }
    if (steps === "2" && valueInputMain.length > 2) {
      setValueInputLastName(valueInputMain);

      document.querySelector(".labelLastName").classList.add("labelLastNameActive");
      document.querySelector(".circle_min:nth-of-type(2)").classList.add("complete");
      setTypeInput("email");

      if (isModificated) {
        setSteps(keepStep);
        setIsModificated(false);
      } else {
        setSteps("3");
      }
    }
    if (steps === "3" && valueInputMain.length > 2 && valueInputMain.includes("@")) {
      setValueInputEmail(valueInputMain);
      document.querySelector(".labelEmail").classList.add("labelEmailActive");
      document.querySelector(".circle_min:nth-of-type(3)").classList.add("complete");
      setTypeInput("number");
      setErrorEmail(false);
      if (isModificated) {
        setSteps(keepStep);
        setIsModificated(false);
      } else {
        setSteps("4");
      }
    } else if (steps === "3") {
      setErrorEmail(true);
    }

    if (steps === "4" && valueInputMain.length > 2) {
      setValueInputCel(valueInputMain);
      document.querySelector(".labelCel").classList.add("labelCellActive");
      document.querySelector(".circle_min:nth-of-type(4)").classList.add("complete");

      if (isModificated) {
        setSteps(keepStep);
        setIsModificated(false);
      } else {
        setSteps("5");
      }
    }
    if (steps === "5") {
      document.querySelector(".labelParentage").classList.add("labelParentageActive");
      document.querySelector(".circle_min:nth-of-type(5)").classList.add("complete");

      if (isModificated) {
        setSteps(keepStep);
        setIsModificated(false);
      } else {
        setSteps("6");
      }
    }
  };

  const animInputMain = () => {
    const input = document.querySelector(".firstLabel");
    input.classList.add("inputMain_anim");
    setTimeout(() => {
      input.classList.remove("inputMain_anim");
    }, 1000);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.target;
    const url = form.getAttribute("action");
    const formData = new FormData(form);

    fetch(url, {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        // console.log("Formulario enviado correctamente");
      })
      .catch((error) => {
        // console.error("Error al enviar el formulario:", error);
      });
  };

  const checkOther = () => {
    if (valueDropdown !== "Otro") {
    }
  };
  useEffect(() => {
    if (valueDropdown === "Otro") {
      document.querySelector(".content_dropdown").classList.add("dropdown_other_hidden");
    } else {
      statusChange("5");
    }
  }, [valueDropdown]);

  return (
    <div className="aboutYou">
      <div className="aboutYou_container ">
        <div className="containerAll">
          <div className="content_steps">
            <div className="content_circles">
              <div className="circle"></div>
              <div className="circle"></div>
              <div className="circle"></div>
            </div>
            <p>PASO 1 de 3</p>
          </div>

          <div
            className={`anim_slider animate__animated animate__bounceInRight ${
              dropdownActive && "pb"
            } `}
          >
            <h1>Cuéntanos un poco sobre ti</h1>

            <div className="content_steps_min">
              <div className="content_circles_min">
                <div className="circle_min"></div>
                <div className="circle_min"></div>
                <div className="circle_min"></div>
                <div className="circle_min"></div>
                <div className="circle_min"></div>
              </div>
            </div>

            <div className="forms">
              <form
                action="https://fmentretenimiento.us20.list-manage.com/subscribe/post?u=ff9efc576ac5ca9d55ee65c64&amp;id=18eebc7387&amp;f_id=00f070eaf0"
                method="post"
                id="mc-embedded-subscribe-form"
                name="mc-embedded-subscribe-form"
                className="validate"
                target="_blank"
                noValidate
                onSubmit={handleSubmit}
              >
                <input type="hidden" name="tags" value="3442667, 3443531" />

                <div className="inputMain">
                  {["1", "2", "3", "4"].includes(steps) && (
                    <label id="labelMain" className={steps >= "5" ? "hide_label" : ""}>
                      <p>
                        {steps === "1"
                          ? "cuál es tu nombre?"
                          : steps === "2"
                          ? "cuál es tu apellido?"
                          : steps === "3"
                          ? "cuál es tu email?"
                          : steps === "4"
                          ? "cuál es tu celular?"
                          : steps === "5"
                          ? "¿Para quién es el video?"
                          : ""}
                      </p>

                      <div className="flex">
                        <input
                          autoComplete="off"
                          type={typeInput}
                          name="main"
                          id="inputMain"
                          value={valueInputMain}
                          onKeyDown={handleKeyDown}
                          onChange={handleUserInput}
                          style={{ paddingRight: "35px" }}
                          disabled={!["1", "2", "3", "4"].includes(steps)}
                        />

                        <img
                          className="arrowAccept"
                          src="/assets/icons/flecha.png"
                          alt="flecha"
                          onClick={() => {
                            statusChange(valueInputMain);
                            setValueInputMain("");
                          }}
                        />
                      </div>

                      {errorEmail && (
                        <p className="text_error_email">
                          <img
                            className="img_error_email"
                            src="/assets/icons/error.png"
                            alt=""
                          />
                          Por favor ingresa un correo válido
                        </p>
                      )}
                    </label>
                  )}

                  {steps === "5" && (
                    <div className="hidden ">
                      <div
                        className={`content_dropdown ${steps >= "6" ? "hide_label" : ""}`}
                        onClick={() => setDropdownActive(!dropdownActive)}
                      >
                        <div className={`${!dropdownActive ? "img" : "img2"}`}>
                          <img src="/assets/icons/flecha.png" alt="flecha" />
                        </div>
                        <p className="label">¿Para quién es el video?</p>
                        <p className="info">{valueDropdown}</p>
                        <div
                          className={`${
                            dropdownActive
                              ? "content_info_dropdown"
                              : "content_info_dropdown_close"
                          }`}
                        >
                          {optionsParents.map((item, i) => (
                            <p
                              key={i}
                              onClick={() => {
                                setDropdownActive(!dropdownActive);
                                setValueDropdown(item.name);
                                checkOther();
                              }}
                            >
                              {item.name}
                            </p>
                          ))}
                        </div>
                      </div>
                      {valueDropdown === "Otro" && (
                        <div className="content_other">
                          <label className="other">
                            Cuál otro?
                            <input
                              onChange={(e) => setValueOther(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  setValueDropdown(valueOther);
                                  statusChange();
                                }
                              }}
                              type="text"
                            />
                            <img
                              onClick={() => {
                                statusChange();
                                setValueDropdown(valueOther);
                              }}
                              className="arrow_other"
                              src="/assets/icons/flecha.png"
                              alt="flecha"
                            />
                          </label>
                        </div>
                      )}
                    </div>
                  )}

                  {steps === "6" && (
                    <div className="button_one">
                      <button
                        type="submit"
                        value="Subscribe"
                        name="subscribe"
                        id="mc-embedded-subscribe"
                        onClick={changePage}
                      >
                        Enviar
                      </button>
                    </div>
                  )}

                  <label htmlFor="mce-FNAME" className="labelName mc-field-group">
                    Nombre
                    <input
                      autoComplete="off"
                      type="text"
                      name="FNAME"
                      defaultValue={valueInputName}
                      id="mce-FNAME"
                      readOnly
                    />
                    <img
                      className="edit"
                      src="/assets/icons/editar.png"
                      alt="editar"
                      onClick={() => {
                        setKeepStep(steps);
                        setIsModificated(true);
                        setSteps("1");
                        setValueLabelMain("¿cuál es tu nombre?");
                        setTypeInput("text");
                      }}
                    />
                  </label>

                  <label htmlFor="mce-LNAME" className="labelLastName">
                    Apellido
                    <input
                      autoComplete="off"
                      type="text"
                      name="LNAME"
                      id="mce-LNAME"
                      defaultValue={valueInputLastName}
                      readOnly
                    />
                    <img
                      className="edit"
                      src="/assets/icons/editar.png"
                      alt="editar"
                      onClick={() => {
                        setKeepStep(steps);
                        setIsModificated(true);
                        setSteps("2");
                        setValueLabelMain("¿cuál es tu apellido?");
                        setTypeInput("text");
                      }}
                    />
                  </label>

                  <label className="labelEmail">
                    Email
                    <input
                      readOnly
                      autoComplete="off"
                      type="email"
                      name="EMAIL"
                      className="email"
                      id="mce-EMAIL"
                      required
                      defaultValue={valueInputEmail}
                    />
                    <img
                      className="edit"
                      src="/assets/icons/editar.png"
                      alt="editar"
                      onClick={() => {
                        setKeepStep(steps);
                        setIsModificated(true);
                        setSteps("3");
                        setValueLabelMain("¿cuál es tu email?");
                        setTypeInput("email");
                      }}
                    />
                  </label>

                  <label className="labelCel">
                    Celular
                    <input
                      readOnly
                      autoComplete="off"
                      type="text"
                      name="PHONE"
                      id="mce-PHONE"
                      defaultValue={valueInputCel}
                    />
                    <img
                      className="edit"
                      src="/assets/icons/editar.png"
                      alt="editar"
                      onClick={() => {
                        setKeepStep(steps);
                        setIsModificated(true);
                        setSteps("4");
                        setValueLabelMain("¿cuál es tu celular?");
                        setTypeInput("number");
                      }}
                    />
                  </label>

                  <label className="labelParentage">
                    Parentesco
                    <input
                      readOnly
                      autoComplete="off"
                      type="text"
                      name="MMERGE3"
                      id="mce-MMERGE3"
                      defaultValue={valueDropdown}
                    />
                    <img
                      className="edit"
                      src="/assets/icons/editar.png"
                      alt="editar"
                      onClick={() => {
                        setKeepStep(steps);
                        setIsModificated(true);
                        setSteps("5");
                      }}
                    />
                  </label>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormPage;
